import { LayoutDashboard, Wallet, ArrowLeftRight, TrendingUp, Coins, Sparkles, Settings, Eye, AlertTriangle, Scale, GitFork } from "lucide-react";

export const NAV_ITEMS = [
    { to: "/", label: "Dashboard", icon: LayoutDashboard, primary: true },
    { to: "/holdings", label: "Holdings", icon: Wallet, primary: true },
    { to: "/watchlist", label: "Watchlist", icon: Eye, primary: true },
    { to: "/transactions", label: "Transactions", icon: ArrowLeftRight, primary: true },
    { to: "/performance", label: "Performance", icon: TrendingUp, primary: true },
    { to: "/ai", label: "AI Analyst", icon: Sparkles, primary: true },
    { to: "/dividends", label: "Dividends", icon: Coins, primary: false },
    { to: "/issues", label: "Open Issues", icon: AlertTriangle, primary: false },
    { to: "/reconcile", label: "Reconcile", icon: Scale, primary: false },
    { to: "/corporate-actions", label: "Corporate Actions", icon: GitFork, primary: false },
    { to: "/settings", label: "Settings", icon: Settings, primary: false },
];

export const TIME_RANGES = ["1D", "1W", "1M", "3M", "6M", "YTD", "1Y", "ALL"];

// Distinct series colors for multi-line charts
export const CHART_COLORS = ["#D2683F", "#C9962F", "#E0A458", "#8C5A3C", "#B4472B", "#E8B04B", "#7A6A55", "#D98F5A"];
// High-contrast palette for multi-series comparison (stock vs indexes/stocks): brand
// terracotta first, then clearly distinct hues so overlaid lines are easy to tell apart.
export const COMPARE_COLORS = ["#D2683F", "#2563EB", "#16A34A", "#9333EA", "#EAB308", "#0891B2", "#DC2626", "#DB2777"];

export const TXN_TYPES = ["BUY", "SELL", "DIVIDEND", "DEPOSIT", "WITHDRAWAL"];

export const TXN_BADGE = {
    BUY: "bg-gain/15 text-gain border-gain/30",
    SELL: "bg-loss/15 text-loss border-loss/30",
    DIVIDEND: "bg-primary/15 text-primary border-primary/30",
    DEPOSIT: "bg-accent/15 text-accent border-accent/30",
    WITHDRAWAL: "bg-muted text-muted-foreground border-border",
    SPINOFF: "bg-accent/15 text-accent border-accent/30",
};
